import React, { useRef, useCallback } from "react"
import { FiMail, FiLock } from "react-icons/fi"
import { Form } from "@unform/web"
import { FormHandles } from "@unform/core"
import * as Yup from "yup"

import { useAuth } from "../../hooks/auth"
import { useToast } from "../../hooks/toast"
import getValidationErrors from "../../utils/getValidationErrors"

import logoImg from "../../assets/Logo.png"

import Input from "../../components/InputUnform"
import Button from "../../components/Button"

import { Container, Content, AnimationContainer, Background } from "./styles"
import returnBackendErrors from "../../utils/returnBackendError"

interface SignInFormData {
  email: string
  password: string
}

const SignIn: React.FC = () => {
  const formRef = useRef<FormHandles>(null)

  const { signIn } = useAuth()
  const { addToast } = useToast()

  const handleSubmit = useCallback(
    async (data: SignInFormData) => {
      try {
        formRef.current?.setErrors({})

        const schema = Yup.object().shape({
          email: Yup.string()
            .required("E-mail obrigatório")
            .email("Digite um e-mail válido"),
          password: Yup.string().required("Senha obrigatória"),
        })

        await schema.validate(data, {
          abortEarly: false,
        })

        try {
          await signIn({
            email: data.email,
            password: data.password,
          })
        } catch (error) {
          addToast({
            title: "Erro",
            type: "error",
            description: returnBackendErrors(error),
          })

          return
        }
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err)

          formRef.current?.setErrors(errors)

          return
        }

        addToast({
          type: "error",
          title: "Erro na autenticação",
          description: "Ocorreu um erro ao fazer login, cheque as credenciais",
        })
      }
    },
    [signIn, addToast]
  )

  return (
    <Container>
      <Content>
        <AnimationContainer>
          <img src={logoImg} width={250} height={250} alt="GoBarber" />

          <Form ref={formRef} onSubmit={handleSubmit}>
            <h1>Login</h1>

            <Input
              name="email"
              icon={FiMail}
              type="text"
              placeholder="E-mail"
            />
            <Input
              name="password"
              icon={FiLock}
              type="password"
              placeholder="Senha"
            />

            <Button type="submit">Entrar</Button>

            {/* <Link to="/forgot-password">Esqueci minha senha</Link> */}
          </Form>

          {/* <Link to="/signup">
            <FiLogIn />
            Criar Conta
          </Link> */}
        </AnimationContainer>
      </Content>
      <Background />
    </Container>
  )
}

export default SignIn
